// @flow
import { localStorage } from '@lib/storages/localStorage';
import { t }            from '@lib/translation';
import { Map }          from 'immutable';
import { Reducer }      from '../../Reducer';
import * as TYPES       from './types';

const DEFAULT_STATE = Map({
    authenticated: false,
    errors:        [],
    token:         null,
    user:          {}
});

export default class AuthReducer extends Reducer {
    NAME = 'Auth';
    alias = {
        [ TYPES.AUTH_LOGIN_SUCCESS ]:  'onSuccess',
        [ TYPES.AUTH_LOGIN_FAIL ]:     'onError',
        [ TYPES.AUTH_LOGIN_LOADING ]:  'onLoading',
        [ TYPES.AUTH_ERRORS_CLEAR ]:   'onClearErrors',
        [ TYPES.AUTH_LOGOUT_SUCCESS ]: 'onLogout'
    };

    /**
     * Success event
     * @param state
     * @param action
     */
    onSuccess ( state = DEFAULT_STATE, action ) {
        if ( action.payload ) {
            let identifier = action.payload.identifier;

            const data = action.payload.data || {};
            const user = action.payload?.data?.user || action.payload?.user;
            const customer = action.payload?.data?.customer || action.payload?.customer;

            if ( user ) {
                identifier = user.email || user.phone;
            }

            localStorage.setItem('last_auth_identifier', identifier);

            if ( user ) {
                return state.set('authenticated', true)
                    .set('loading', false)
                    .set('error', null)
                    .set('token', data.token)
                    .set('user', user)
                    .set('customer', customer);
            }
        }

        return state.set('loading', false);
    }

    onLoading ( state = DEFAULT_STATE, action ) {
        return state.set('loading', action.payload);
    }

    /**
     * Error event
     * @param state
     * @param action
     */
    onError ( state = DEFAULT_STATE, action ) {
        if ( action.payload ) {
            const { data, status } = action.payload;
            let message = `${ t('Something went wrong') }`;

            // eslint-disable-next-line default-case
            switch ( data.error || data.detail ) {
                case 'invalid_credentials':
                    message = `${ t('Invalid Credentials') }`;
                    break;
                default:
                    // eslint-disable-next-line default-case
                    switch ( status ) {
                        case -1:
                            message = `${ t('No network connection') }`;
                            break;
                        case 500:
                            message = `${ t('Server connection error') }`;
                            break;
                    }
            }

            return state.set('authenticated', false)
                .set('loading', false)
                .set('user', {})
                .set('error', { message })
                .set('token', null);
        }

        return state.set('loading', false);
    }

    /**
     * Logout event
     * @param state
     */
    onLogout ( state ) {
        return state.set('authenticated', false)
            .set('loading', false)
            .set('error', null)
            .set('token', null)
            .set('user', {});
    }

    /**
     * Clear Auth errors
     * @param state
     */
    onClearErrors ( state ) {
        return state.set('error', null);
    }

    /**
     *
     * @return {*|Map<any, any>|Map<string, Array|{}|boolean>}
     */
    onDefault ( state = DEFAULT_STATE ) {
        return state;
    }
}
